// 消息信息管理
import {api} from '@/service/api'
import apiList from '@/service/apiList'
const typeName = (type) => {
  let text = ''
  switch (type) {
    case '1':
      text = '价格消息'
      break
    case '2':
      text = '商品消息'
      break
    case '3':
      text = '订单消息'
      break
    case '4':
      text = '库存消息'
      break
    default:
      break
  }
  return text
}
const state = {
  noArrivedOrder:{
    "orderCount": 0,
    "asOrderCount": 0,
    show:false
  },
  noArrivedOrderInterval: '', // 定时未任务
}

const mutations = {
  // 设置未读消息列表
  SET_NO_ARRIVED_ORDER: (state, message) => {
    state.noArrivedOrder = message
  },
  // 清除定时任务
  CLEAR_INTERVAL: (state) => {
    clearInterval(state.noArrivedOrderInterval)
  },
  INTERVAL: (state, interval) => {
    state.noArrivedOrderInterval = interval
  },
  SWITCH_MESSAGE_SHOW: (state, status) => {
    state.noArrivedOrder.show = status
  },
}

const actions = {
  // 获取未到分仓订单
  async getNoArrivedOrder ({ commit, dispatch }, message) {
    let getMessage = () => {
      api.get(apiList.getnoArrivedOrder, {})
        .then(res => {
          if (res.code === 200) {
            let data = res.data
            // let data = {
            //   "orderCount": 10,
            //   "asOrderCount": 0,
            // }
            if(data.orderCount == 0 && data.asOrderCount == 0){
              data.show = false
            }else if(localStorage.getItem('is_jgj')==='1'){
              data.show = false
            }else{
              data.show = true
            }
            commit('SET_NO_ARRIVED_ORDER', data)
          }
        })
    }
    getMessage()
    dispatch('clearInterval')
    let interval = setInterval(getMessage, 30 * 60 * 1000)
    commit('INTERVAL', interval)
  },
  // 清除定时任务
  clearInterval ({commit}) {
    // console.log("清除定时任务");
    commit('CLEAR_INTERVAL')
  },
  switchPlatformOrderMessageShow({ commit, dispatch }, STATUS){
    // console.log('切换显示');
    commit('SWITCH_MESSAGE_SHOW',STATUS)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/platform.js